import * as React from 'react';
import { Button } from './primary-button.styles';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  disabled?: boolean;
}

/**
 * @deprecated
 */
export const PrimaryButton: React.FC<Props> = (props) => {
  return <Button {...props}>{props.children}</Button>;
};
